/**
 * @prettier
 */
import {createSelector} from 'reselect';

import {getAbacusTests, getNavigation, getTranslations} from './store';
import {getIsMobile} from './system';
import getAvailabilityCalendar from './availabilityCalendar';
import {isInBucketData} from '../utils/abacusHelper';

const NAV_TABS = {
    amenities: 'amenities',
    map: 'map',
    overview: 'overview',
    rates_availability: 'rates-availability',
    reviews: 'reviews'
};

const getNavLabels = createSelector(
    [getTranslations, getAvailabilityCalendar],
    (trans, availabilityCalendar) => {
        return {
            overview: trans.navOverview,
            amenities: trans.navAmenities,
            reviews: trans.navReviews,
            map: trans.navMap,
            availability: availabilityCalendar.shouldShowRates
                ? trans.navRatesAvailability
                : trans.navAvailability,
            photos: trans.navPhotos
        };
    }
);

const getNavTabsDesktop = createSelector(
    [getNavLabels, getAbacusTests],
    (navLabels, abacusTests) => [
        {id: NAV_TABS.overview, href: `#${NAV_TABS.overview}`, label: navLabels.overview},
        {id: NAV_TABS.amenities, href: `#${NAV_TABS.amenities}`, label: navLabels.amenities},
        {id: NAV_TABS.reviews, href: `#${NAV_TABS.reviews}`, label: navLabels.reviews},
        {id: NAV_TABS.map, href: `#${NAV_TABS.map}`, label: navLabels.map},
        ...(isInBucketData(abacusTests, 'ha_pdp_desktop_gallery', 1)
            ? [{id: 'photo-gallery', href: '#photo-gallery', label: navLabels.photos}]
            : []),
        {
            id: NAV_TABS.rates_availability,
            href: `#${NAV_TABS.rates_availability}`,
            label: navLabels.availability
        }
    ]
);

// ha_pdp_mweb_sticky_nav
const getNavTabsMobile = createSelector(
    [getNavLabels],
    (navLabels) => [
        {id: NAV_TABS.overview, href: `#${NAV_TABS.overview}`, label: navLabels.overview},
        {id: NAV_TABS.reviews, href: `#${NAV_TABS.reviews}`, label: navLabels.reviews},
        {id: NAV_TABS.map, href: `#${NAV_TABS.map}`, label: navLabels.map},
        {
            id: NAV_TABS.rates_availability,
            href: `#${NAV_TABS.rates_availability}`,
            label: navLabels.availability
        },
        {id: NAV_TABS.amenities, href: `#${NAV_TABS.amenities}`, label: navLabels.amenities}
    ]
);

const getNavTabs = createSelector(
    [getNavTabsDesktop, getNavTabsMobile, getIsMobile],
    (navTabsDesktop, navTabsMobile, isMobile) => {
        return isMobile ? navTabsMobile : navTabsDesktop;
    }
);

const getNavActiveTabIndex = createSelector(
    [getNavigation],
    (navigation) => navigation.navActiveTabIndex
);

const getNavData = createSelector(
    [getNavTabs, getNavActiveTabIndex, getIsMobile],
    (navTabs, activeIndex, isMobile) => ({navTabs, activeIndex, isMobile})
);

export default getNavData;
export {
    getNavLabels,
    getNavTabs,
    getNavTabsMobile,
    getNavTabsDesktop,
    getNavActiveTabIndex,
    getNavData,
    NAV_TABS
};
